import { render, staticRenderFns } from "./ContentStaticProviderWait.vue?vue&type=template&id=5ae384b2&scoped=true&"
import script from "./ContentStaticProviderWait.vue?vue&type=script&lang=js&"
export * from "./ContentStaticProviderWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae384b2",
  null
  
)

export default component.exports